export default {_name:'grid.form.section.button',module:'Card/Form',view:'Element/Section/AsButton',options:{component:'section',xs:8,ms:8,block:{xs:8,ms:8}}}